import { StyleSheet } from 'react-native';
import { theme } from '../../../theme';

export const reviewStepStyles = StyleSheet.create({
  container: {
    flex: 1,
    minHeight: 0,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingHorizontal: 16,
    paddingTop: 4,
    paddingBottom: 10,
  },
  title: {
    flex: 1,
    fontSize: 18,
    fontWeight: '700',
    color: theme.black,
  },
  scorePill: {
    fontSize: 12,
    color: theme.gray[500],
    fontWeight: '600',
  },
  scoreVal: {
    color: theme.accentDark,
    fontWeight: '700',
  },
  scroll: {
    flex: 1,
  },
  scrollContent: {
    paddingHorizontal: 16,
    paddingBottom: 16,
    gap: 8,
  },
  // One card per pick: the header row plus, when expanded, its in-place editor (AC-4.7).
  pickCard: {
    backgroundColor: theme.background.card,
    borderRadius: theme.borderRadius.md,
  },
  pickRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  pickToggle: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  // Overlapping home/away kits on the left of each pick, matching the deck/list cards (design 2a).
  pickKits: {
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 0,
  },
  pickKitAway: {
    marginLeft: -9,
  },
  pickInfo: {
    flex: 1,
    minWidth: 0,
  },
  pickMatch: {
    fontSize: 13,
    fontWeight: '600',
    color: theme.black,
  },
  pickSide: {
    fontSize: 11,
    color: theme.gray[500],
    marginTop: 1,
  },
  pickOdds: {
    fontSize: 14,
    fontWeight: '700',
    color: theme.accentDark,
  },
  removeBtn: {
    width: 26,
    height: 26,
    borderRadius: 13,
    backgroundColor: theme.background.inset,
    alignItems: 'center',
    justifyContent: 'center',
  },
  removeText: {
    fontSize: 13,
    color: theme.gray[400],
    lineHeight: 15,
  },
  // Compact single-row stake bar, pinned in the footer above Send (user: no scrolling to reach it,
  // and it shouldn't eat vertical space).
  stakeBar: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  stakeTitle: {
    fontSize: 12,
    fontWeight: '700',
    color: theme.gray[600],
  },
  stakeBtn: {
    width: 34,
    height: 34,
    borderRadius: theme.borderRadius.md,
    backgroundColor: theme.background.card,
    borderWidth: 1,
    borderColor: theme.gray[200],
    alignItems: 'center',
    justifyContent: 'center',
  },
  stakeBtnDisabled: {
    opacity: 0.4,
  },
  stakeBtnText: {
    fontSize: 17,
    color: theme.gray[600],
  },
  stakeValueBox: {
    minWidth: 74,
    minHeight: 34,
    paddingHorizontal: 10,
    borderRadius: theme.borderRadius.md,
    backgroundColor: theme.background.card,
    borderWidth: 1,
    borderColor: theme.gray[200],
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
  },
  stakeCoin: {
    width: 13,
    height: 13,
  },
  stakeValue: {
    fontSize: 15,
    fontWeight: '700',
    color: theme.accent,
  },
  stakeSpacer: {
    flex: 1,
  },
  potLabel: {
    fontSize: 12,
    color: theme.gray[500],
  },
  potValue: {
    fontSize: 13,
    fontWeight: '700',
    color: theme.accent,
  },
  warnText: {
    fontSize: 11.5,
    color: theme.error,
    lineHeight: 16,
    marginBottom: 6,
  },
  footer: {
    flexShrink: 0,
    paddingHorizontal: 16,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: theme.background.inset,
    borderTopWidth: 1,
    borderTopColor: theme.gray[200],
  },
  sendBtn: {
    width: '100%',
    minHeight: 44,
    borderRadius: theme.borderRadius.md,
    backgroundColor: theme.primary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  sendBtnDisabled: {
    backgroundColor: theme.background.cardElevated,
  },
  sendText: {
    fontSize: 15,
    fontWeight: '700',
    color: theme.onPrimary,
  },
  sendTextDisabled: {
    color: theme.gray[400],
  },
});
